import { useEffect } from 'react';
import { useSelector } from 'react-redux';

import { useApplicationStore } from './applicationStore';
import type { StoreRootState } from '../types/StoreRootState';

export function useSyncReduxToZustand() {
  const realm = useSelector(
    (state: StoreRootState) => state.application?.realm?.realm
  );
  const token = useSelector(
    (state: StoreRootState) => state.authentication?.userData?.token
  );

  const { setRealm, setToken } = useApplicationStore();

  useEffect(() => {
    if (realm) {
      setRealm(realm);
    }
  }, [realm, setRealm]);

  useEffect(() => {
    if (token) {
      setToken(token);
    }
  }, [token, setToken]);
}
